// extracted by mini-css-extract-plugin
export default {"bookmarkChip":"Pg_7_3_bookmarkChip__8+2Tk"};